$(document).ready(function () {
  $(".purchase-option").change(function () {
    $(".option-card").each(function () {
      $(this).removeClass("active");
    });
    var sellingPlan = $(this)
      .closest(".option-card")
      .parent()
      .find(".selling-plan");

    var par = $(this).parent();
    var sellingPlanVal = $(this).closest(".delivery-dropdown").val();
    $(par).addClass("active");
    if ($(this).val() === "subscribe") {
      $(sellingPlan).val(sellingPlanVal);
    } else {
      $(sellingPlan).val("");
    }
  });
  $(".delivery-dropdown").change(function () {
    var price_wrap = $(this).prev();
    var selectedPrice = $(this).find("option:selected").data("price");
    console.log("Selected data-price:", selectedPrice);
    var discount_price = $(price_wrap).find(".discount-price");
    $(discount_price).html(selectedPrice);
    var sellingPlanVal = $(this).val();
    var sellingPlan = $(this).closest(".selling-plan");
    console.log("sellingplan", sellingPlan);
    $(this)
      .closest(".option-card")
      .parent()
      .find(".selling-plan")
      .val(sellingPlanVal);
  });
  $(".t4s-push-menu-btn").click(function () {
    $(".t4s-close-overlay").css("visibility", "hidden");
  });
  var m = $(".wrapper-height").outerHeight();
  $(".megamenu-wrapper").each(function () {
    $(this).css("top", m + "px");
  });
  $(".overlay-wrapper-menu").each(function () {
    $(this).css("top", m + "px");
  });
  $(".has--children.menu-has__offsets").mouseenter(function () {
    // $("#bg-img-header-desktop").addClass("unactive");
    setTimeout(function () {
      // $("#bg-img-header-desktop").addClass("unactive-image");
    }, 250);
  });
  $(".has--children.menu-has__offsets").mouseleave(function () {
    // $("#bg-img-header-desktop").removeClass("unactive");
    setTimeout(function () {
      // $("#bg-img-header-desktop").removeClass("unactive-image");
    }, 250);
  });
  function updateHeaderStyles() {
    var header = document.getElementById("myHeader");
    // var bgimg = document.getElementById("bg-img-header-desktop");
    // var bgimgMobile = document.getElementById("bg-img-header-mobile");

    if (header.classList.contains("fixed-header")) {
      header.style.backgroundImage = "none";
      header.style.backgroundColor = "#E8F2FF";
      // bgimg.style.display = "none";
      // bgimgMobile.style.display = "none";
      // bgimg.classList.add("unactive");
      // bgimgMobile.classList.add("unactive");
      setTimeout(function () {
        // bgimg.classList.add("unactive-image");
      }, 250);
    } else {
      // bgimg.style.display = "block";
      // bgimgMobile.style.height = "block";
      header.style.height = "";
      header.style.backgroundColor = "";
      // bgimg.classList.remove("unactive");
      // bgimgMobile.classList.remove("unactive");
      setTimeout(function () {
        // bgimg.classList.add("unactive-image");
      }, 250);
    }
  }
  window.addEventListener("scroll", function () {
    var header = document.getElementById("myHeader");
    var scrollPosition = window.scrollY;
    var headerHeight = header.offsetHeight;
    if (scrollPosition > 5) {
      header.classList.add("fixed-header");
    } else {
      if ($(window).outerWidth() < 1025) {
        if ($("body").hasClass("is--opend-drawer")) {
        } else {
          header.classList.remove("fixed-header");
        }
      } else {
        header.classList.remove("fixed-header");
      }
    }
    updateHeaderStyles();
  });
  updateHeaderStyles();
});

$("[data-menu-drawer]").click(function (e) {
  // var bgimgMobile = document.getElementById("bg-img-header-mobile");
  var header = document.getElementById("myHeader");
  // bgimgMobile.classList.add("unactive");
  // bgimgMobile.classList.add("unactive-image");
  var v = parseInt($("#myHeader").outerHeight());
  console.log("vv", v);
  // var topBar = parseInt($("#shopify-section-top-bar").outerHeight());
  var announcement = 0;
  if ($("#shopify-section-announcement-bar").length > 0) {
    announcement = parseInt(
      $("#shopify-section-announcement-bar").outerHeight()
    );
  }
  setTimeout(function () {}, 500);
  if ($("#myHeader").hasClass("fixed-header")) {
    $("#t4s-menu-drawer").css("top", v + "px");
    $(".t4s-drawer-menu__close").css("top", "0px");
  } else {
    v = v + announcement;
    $("#t4s-menu-drawer").css("top", v + "px");
    $(".t4s-drawer-menu__close").css("top", announcement + "px");
  }
});
$("[data-drawer-close]").click(function () {
  // var bgimgMobile = document.getElementById("bg-img-header-mobile");
  var header = document.getElementById("myHeader");
  if (header.classList.contains("fixed-header")) {
  } else {
    // bgimgMobile.classList.remove("unactive");
    setTimeout(function () {
      // bgimgMobile.classList.remove("unactive-image");
    }, 250);
  }
});

//   function updateHeaderStyles() {
//     var header = document.getElementById('myHeader');
//     if (header.classList.contains('fixed-header')) {
//         header.style.backgroundImage = 'none';
//         header.style.height = '100px';
//         header.style.backgroundColor = '#c3d4e8';
//     } else {
//         header.style.backgroundImage = 'url("https://happimess.com/cdn/shop/files/Vector_6.svg?v=1697701166&width=2160")';
//       }
// }
// window.addEventListener('scroll', function() {
//     var header = document.getElementById('myHeader');
//     var scrollPosition = window.scrollY;
//     if (scrollPosition > 100) {
//         header.classList.add('fixed-header');
//     } else {
//         header.classList.remove('fixed-header');
//     }
//     updateHeaderStyles();
// });
// updateHeaderStyles();

window.onscroll = function () {
  myFunction();
};

var header = document.getElementById("myHeader");
var sticky = header.offsetTop;

function myFunction() {
  // var v = $("#myHeader").outerHeight() - 5;
  var v = parseInt($("#myHeader").outerHeight());
  // var topBar = parseInt($("#shopify-section-top-bar").outerHeight());
  var announcement = parseInt(
    $("#shopify-section-announcement-bar").outerHeight()
  );
  if (window.pageYOffset > sticky) {
    header.classList.add("fixed-header");
  } else {
    header.classList.remove("fixed-header");
  }
  if ($("#myHeader").hasClass("fixed-header")) {
    $("#t4s-menu-drawer").css("top", v + "px");
    setTimeout(function () {
      // $(".bg-img-header-desktop").addClass("unactive-image");
    }, 250);
    // $("#menu-mb__ul").css("padding-top", v);
  } else {
    v = v + announcement;
    $("#t4s-menu-drawer").css("top", v + "px");
    // $("#menu-mb__ul").css("padding-top", v);
    setTimeout(function () {
      // $(".bg-img-header-desktop").removeClass("unactive-image");
    }, 250);
  }
}
$(".overlay-wrapper-menu").hover(function () {
  $("li.is-action__hover").removeClass("is-action__hover");
  if (!$("#myHeader").hasClass("fixed-header")) {
    // $(".bg-img-header-desktop").removeClass("is-action__hover");
    setTimeout(function () {
      // $(".bg-img-header-desktop").removeClass("unactive-image");
    }, 250);
  }
});
$(".overlay-wrapper-menu").click(function () {
  $("li.is-action__hover").removeClass("is-action__hover");
  if (!$("#myHeader").hasClass("fixed-header")) {
    // $(".bg-img-header-desktop").removeClass("is-action__hover");
    setTimeout(function () {
      // $(".bg-img-header-desktop").removeClass("unactive-image");
    }, 250);
  }
});
window.onresize = function () {
  myFunction();
  var m = $(".wrapper-height").outerHeight();
  $(".megamenu-wrapper").each(function () {
    $(this).css("top", m + "px");
  });
  $(".overlay-wrapper-menu").each(function () {
    $(this).css("top", m + "px");
  });
};

$("body").on("click", "#notify_button", function (e) {
  var pid = parseInt($(this).data("pid"));
  var email = $("#notify_email").val();
  var vid = parseInt($(".t4s-product__select").val());
  if (email != "") {
    $.ajax({
      type: "POST",
      url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
      data: {
        a: "UdxXz2",
        email: email,
        variant: vid,
        platform: "shopify",
      },
      success: function (response) {
        console.log(response);
      },
      error: function (response) {
        console.log(response);
      },
    });
    $(".notify-main").hide();
    $(".thank-msg").show();
  }
});
$(document).on("variant:changed", function (evt) {
  console.log(evt.currentVariant);
  var cvariant = evt.currentVariant;
  var coptions = cvariant.options.length;
  var cid = evt.currentVariant.id;
  var sk = "";
  console.log(coptions);
  $(".v-options option").each(function () {
    console.log(cid);
    console.log($(this).val());
    sk = "";
    if ($(this).val() == cid) {
      sk = $(this).data("sku");
      console.log($(this).data("sku"));

      $(".t4s-sku-wrapper").css("display", "block");

      $(".t4s-sku-value").text(sk);
    }
  });
  if (cvariant.available == true) {
    console.log("hii");
    // setTimeout(function(){
    //   $("#appikon-bis-inline-form-wrapper").removeClass("active");

    // },1000);
    $(".notify-main").hide();
    // $(".btn-div").addClass("active");
  } else {
    console.log("hii1");
    // setTimeout(function(){

    //   $("#appikon-bis-inline-form-wrapper").addClass("active");
    // },1000);

    $(".notify-main").show();
    // $(".btn-div").removeClass("active");
  }
  var d = $("#dimensions-enable").val();
  if (d == true) {
    $(".size-info-ext").each(function () {
      $(this).removeClass();
    });
    $("#ext-" + cvariant.id).addClass("active");
  }

  // $('[data-variant-toggle]').hide(0);
  // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
});

// moment video
// $('.index-product-video-img').click(function(e){
$("body").on("click", ".index-product-video-img", function (e) {
  e.preventDefault();
  console.log("hii");
  $(".video-popup-section").addClass("video-popup-section-active");

  var d = $(this).data("urls");

  var vid = d.split(" - ");
  var h = "";
  $(vid).each(function (i, d) {
    if (d != "" && d.indexOf("mp4") != -1) {
      $("#vid-popup").attr("src", d);
      $("#vid-popup")[0].load();
      $("#vid-popup").trigger("play");
    }
  });
});

$(".video-close-button").click(function () {
  $("#vid-popup").attr("src", "");
  $(".video-popup-section").removeClass("video-popup-section-active");
});
